<template>
    <div class="add-sentence" @keyup.enter.prevent="onEnter">
        <Spinner v-if="loading">Adding sentences...</Spinner>
        <EditorLightSentenceControl
            :bookpart="falseBookpart"
            adding
            @update:model-value="onUpdateSpeaker"
        />
        <ContentEditableInput
            ref="input"
            v-model="text"
            :disabled="loading"
            :class="{ 'add-sentence__input add-sentence__input--last': last }"
            placeholder="Type your text here..."
            @blur="addSentence"
        />
    </div>
</template>

<script>
import ContentEditableInput from '@speechki-frontend/shared/ui/ContentEditableInput/ContentEditableInput.vue';
import EditorLightSentenceControl from '../EditorLightSentenceControl/EditorLightSentenceControl.vue';

import { addSentence } from '../../services/addSentence';

import { mapActions } from 'vuex';

export default {
    name: 'AddSentence',
    components: {
        ContentEditableInput,
        EditorLightSentenceControl
    },
    props: {
        bookpart: {
            type: Object,
            required: true
        },
        last: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            text: '',
            speaker: this.bookpart.speaker,
            falseBookpart: {
                language: this.bookpart.speaker.language,
                speaker: {
                    ...this.bookpart.speaker
                }
            },
            loading: false
        };
    },
    methods: {
        ...mapActions('pagedBookparts', ['fetchInitialBookparts']),
        async addSentence() {
            if (!this.text.trim() || this.loading) return;
            try {
                this.loading = true;
                const data = {
                    parent: this.bookpart.id,
                    speaker: this.falseBookpart.speaker.id,

                    sentences: this.text
                        .trim()
                        .replace(/\n/g, ' ')
                        .match(/.{1,500}/g)
                };

                await addSentence(this.$route.params.id, data);

                await this.fetchInitialBookparts({
                    page: this.$route.query.page,
                    preserveScroll: true
                });
                this.text = '';
                this.loading = false;

                this.$refs.input.blur(/* skip next event */ true);
            } catch (e) {
                this.$store.dispatch('pushToast', {
                    type: 'error',
                    title: `Text can't be edited`,
                    text: `You’ve reached the editing limit in this project. <br> To read more about how editing limits in projects work, please follow <a class='link' href='https://speechki.org/faq' target='_blank'>this link</a>`,
                    theme: 'big'
                });

                console.log(e);
                this.loading = false;
            }
        },
        onEnter(event) {
            if (!event.shiftKey) {
                event.preventDefault();
                this.addSentence();
            }
        },
        onUpdateSpeaker(event) {
            this.falseBookpart = {
                ...this.falseBookpart,
                speaker: event
            };
        }
    }
};
</script>

<style lang="scss" src="./AddSentence.scss"></style>
